import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ErrorHandler } from '../../common/errorHandler';
import { UserService } from '../../services/user.service';
import { GroupService } from '../../services/group.service';
import { User } from '../../models/user.model';
import { ResultCode } from '../../enums/resultcode.enum';
import { Salutation } from '../../enums/salutation.enum';
import { Group } from '../../models/group.model';

@Component({
    selector: 'user-detail',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.css'],
    providers: [UserService, GroupService, ErrorHandler]
})
export class UserDetailComponent implements OnInit {
    user: User;
    groups: Array<Group>;
    salutations: Array<Salutation>;
    isDataAvailable = false;
    messages: Array<string> = null;
    private userId: string;

    constructor(
        private userService: UserService,
        private groupService: GroupService,
        private errorHandler: ErrorHandler,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.user = new User();
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.salutations = [];
            this.salutations.push(Salutation.None);
            this.salutations.push(Salutation.Frau);
            this.salutations.push(Salutation.Herr);

            this.getGroups();
            if (params['userId'] && params['userId'] !== '0') {
                this.userService.getUser(params['userId'])
                    .then(user => {
                            this.user = user;
                            this.isDataAvailable = true;
                        }
                    )
                    .catch(error => {
                        this.errorHandler.do(error);
                    });
                } else {
                    this.isDataAvailable = true;
                }
        });
    }

    getGroups(): void {
        this.groupService.getGroups()
            .then(groups => {
                this.groups = groups;
                this.isDataAvailable = true;
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    save(): void {
        if (this.user.id === undefined) {
            this.insert();
        } else {
            this.update();
        }
    }

    private update(): void {
        this.isDataAvailable = false;
        this.userService.updateUser(this.user)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['users']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    private insert(): void {
        this.isDataAvailable = false;
        this.userService.addUser(this.user)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['users']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    cancel(): void {
        this.router.navigate(['users']);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user-detail/user-detail.component.ts